import { WorkspaceMergeOptionsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/merge_options')({
  component: WorkspaceMergeOptionsRoute,
});
